import { render, staticRenderFns } from "./LandingInput.vue?vue&type=template&id=6379c962&scoped=true&"
import script from "./LandingInput.vue?vue&type=script&lang=ts&"
export * from "./LandingInput.vue?vue&type=script&lang=ts&"
import style0 from "./LandingInput.vue?vue&type=style&index=0&id=6379c962&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6379c962",
  null
  
)

export default component.exports